module.exports = __webpack_public_path__ + "img/104.0ad2e657.jpg";